import React from 'react';
import { s as styleInject } from './style-inject.es-4a6aca40.js';

var css_248z = ".sunzi_components__loading-3Tls6 {\n  width: 42px;\n  height: 42px;\n}\n.sunzi_components__loading-3Tls6 svg {\n  width: 100%;\n  height: 100%;\n  -webkit-animation: sunzi_components__loading-rotate-1KUXW 2s linear infinite;\n          animation: sunzi_components__loading-rotate-1KUXW 2s linear infinite;\n}\n.sunzi_components__loading-3Tls6 svg > circle {\n  -webkit-animation: sunzi_components__loading-dash-1ptfj 1.5s ease-in-out infinite;\n          animation: sunzi_components__loading-dash-1ptfj 1.5s ease-in-out infinite;\n  stroke-dasharray: 90, 150;\n  stroke-dashoffset: 0;\n  stroke-width: 6;\n  stroke-linecap: round;\n  stroke: #fff;\n}\n@-webkit-keyframes sunzi_components__loading-rotate-1KUXW {\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes sunzi_components__loading-rotate-1KUXW {\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes sunzi_components__loading-dash-1ptfj {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -40px;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -120px;\n  }\n}\n@keyframes sunzi_components__loading-dash-1ptfj {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -40px;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -120px;\n  }\n}\n";
var styles = {"loading":"sunzi_components__loading-3Tls6","loadingRotate":"sunzi_components__loading-rotate-1KUXW","loadingDash":"sunzi_components__loading-dash-1ptfj"};
styleInject(css_248z);

var Loading = function (_a) {
  var size = _a.size,
      color = _a.color;
  return React.createElement("div", {
    className: styles.loading,
    style: {
      width: size,
      height: size
    }
  }, React.createElement("svg", {
    viewBox: "25 25 50 50"
  }, React.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "20",
    fill: "none",
    style: {
      stroke: color
    }
  })));
};

export default Loading;
